<template>
    <div class="content">
        <h1>ZEUGNISSE</h1>
        <div class="reports-content">
            <div v-for="(item, index) in reports" :key="index">
                <div class="flex-container">
                    <div class="flex-item-left">
                        {{ item.Name }}
                        <a
                            href="javascript:void(0);"
                            @click="showReport(item.Id)">
                            <span v-if="item.Display" class="show-link">
                                <i class="fas fa-angle-up" title="Ausblenden"></i>
                            </span>
                            <span v-else class="show-link">
                                <i class="fas fa-angle-down" title="Einblenden"></i>
                            </span>
                        </a>
                    </div>
                    <div class="flex-item-right">
                        <a
                            v-if="item.Id === 'CSZZ' || item.Id === 'TTAZ'"
                            :href="previewUrl + (item.Id) + '.pdf'"
                            class="blank-link"
                            target="_blank">
                            <i class="fas fa-external-link-alt" title="In neuem Tab öffnen"></i>
                        </a>
                        <a
                            v-else
                            :href="previewUrl + (item.Id) + '.jpg'"
                            class="blank-link"
                            target="_blank">
                            <i class="fas fa-external-link-alt" title="In neuem Tab öffnen"></i>
                        </a>
                    </div>
                </div>
                <div :id="'Report_' + item.Id" class="report-preview">
                    <img :src="previewUrl + (item.Id) + '.jpg'">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import siteConfig from '@/assets/js/mixins/siteConfig';
import JQuery from 'jquery';
let $ = JQuery;

export default {
    name: 'Home',
    mixins: [
        siteConfig
    ],
    data() {
        return {
            reports: [{
                Id: 'CSZZ',
                Name: 'Cologne Systems Zwischenzeugnis',
                Display: false
            }, {
                Id: 'TTAZ',
                Name: 'TravelTainment Arbeitszeugnis',
                Display: false
            }, {
                Id: 'IHKPZ',
                Name: 'IHK Prüfungszeugnis',
                Display: false
            }, {
                Id: 'MRZG',
                Name: 'Mircorep Zeugnis',
                Display: false
            }, {
                Id: 'MRZN',
                Name: 'Mircorep Zenzuren',
                Display: false
            }, {
                Id: 'FZJ',
                Name: 'Forschungszentrum Jülich',
                Display: false
            }, {
                Id: 'EWGBR',
                Name: 'Eckel & Weißenfeld GbR',
                Display: false
            }, {
                Id: 'ABI1',
                Name: 'Abitur Zeugnis Seite 1',
                Display: false
            }, {
                Id: 'ABI2',
                Name: 'Abitur Zeugnis Seite 2',
                Display: false
            }, {
                Id: 'ABI3',
                Name: 'Abitur Zeugnis Seite 3',
                Display: false
            }, {
                Id: 'ABI4',
                Name: 'Abitur Zeugnis Seite 4',
                Display: false
            }],
            previewUrl: siteConfig.previewUrl
        };
    },
    methods: {
        showReport(id) {
            $('#Report_' + id).slideToggle('fast');
            this.reports.forEach(item => {
                if (item.Id === id) {
                    item.Display = !item.Display;
                }
            });
        },

        emitLogData(page, action) {
            this.$emit(
                'log-it',
                '{"page": "' + page + '", "action": "' + action + '"}'
            );
        }
    },
    mounted() {
        this.emitLogData('home', 'visit');
    },
    beforeDestroy() {
        this.emitLogData('home', 'leave');
    }
};
</script>

<style lang="scss" scoped>
    .reports-content {
        margin-top: 20px;
    }
    .row {
        margin: 0 -30px 20px -30px !important;
    }
    .report-link {
        text-align: right;
    }
    .blank-link {

    }
    a {
        color: #42b983;
    }
    .fas {
        margin-right: 10px;
    }
    .report-preview {
        width: 100%;
        display: none;
        margin-bottom: 20px;
    }

    .flex-container {
        display: flex;
        margin: 0 0 10px 0;
    }
    .flex-item-left {
        flex-grow: 11;
    }
    .flex-item-right {
        flex-grow: 1;
        text-align: right;
        margin-right: -12px;
    }
</style>
